module.exports = __webpack_public_path__ + "0f24b5cca899446f1cc2245c47865950.jpg";